import anime from "animejs";




(function($) {
  var header = $(".header");

  $(".backplate").click(function() {
    $(".menu-tendina").removeClass("menu-tendina--active");
    $(".o-popup").removeClass("o-popup--open");
    $(".hamburger").removeClass("is-active");
    $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
    $(".btn-nav").removeClass("btn-nav--active");
    $(this).removeClass("backplate--open");
  });


  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    $("body").toggleClass('overflow-hidden');
    $(".hamburger").toggleClass("is-active");
    // $(".backplate").toggleClass("backplate--open");
  });



  // Header follow
  var scrollA = 0;
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    // if (scroll >= $(window).height()) {
    //   header.addClass("active-scroll");
    // } else {
    //   header.removeClass("active-scroll");
    // }

    if (scroll >= 300) {
      if(scrollA == 0) {
        header.addClass("header-v1--scroll-in")
        .delay(500)
        .queue(function(next){
          header.addClass("header-v1--scroll").removeClass("header-v1--scroll-in");
          next();
        })
        scrollA = 1;
      }
    } if (scroll < 300) {
      if(scrollA == 1) {
        header.addClass("header-v1--scroll-out")
        .delay(500)
        .queue(function(next2){
          header.removeClass("header-v1--scroll").removeClass("header-v1--scroll-out");
          next2();
        })
        scrollA = 0;
      }
    }
  });

})(jQuery);



